import { useRouter } from 'next/router';
import { useGetGroup, useGetGroupEvents } from 'legacy/groups/hooks';
import { useEffect } from 'react';

function useOrganizationDashboard(
  afterStartDate: string,
  beforeStartDate: string
) {
  const router = useRouter();

  const {
    data: events,
    isLoading,
    isError,
    refetch: refetchEvents
  } = useGetGroupEvents({
    groupId: router.query.organizationId as string,
    afterStartDate,
    beforeStartDate
  });

  const { data: organization, isLoading: isLoadingOrganizationLoading } =
    useGetGroup({
      groupId: router.query.organizationId as string
    });

  useEffect(() => {
    refetchEvents();
  }, [afterStartDate, beforeStartDate]);

  return {
    data: {
      events,
      isLoading,
      isError,
      organization,
      isLoadingOrganizationLoading
    },
    refetchEvents
  };
}

export default useOrganizationDashboard;
